import React from "react"
import { createIcon } from "@chakra-ui/react"

export default createIcon({
  displayName: "MezoSignIcon",
  viewBox: "0 0 88 88",
  path: [
    <path fill="#FF004D" d="M0 0h88v88H0z" />,
    <path
      fill="#fff"
      d="m33.333 44.032-6.249 5.999C21.68 55.22 12 51.59 12 44.032L28 44c0-7.557 9.518-11.343 15.085-5.998L49.333 44c0-7.557 9.518-11.343 15.085-5.998L70.666 44H76c0 7.557-9.518 11.343-15.084 5.998L54.667 44c0 7.557-9.517 11.343-15.084 5.998L33.335 44"
    />,
  ],
})
